// Booking and campaign exports stay on Angular, which holds the state they need.
export const REPORT_TYPES = {
  PAYMENT: 'payment',
  PAYMENT_STATUS: 'payment_status',
  ESTIMATE: 'estimate',
  CLIENT: 'client',
};

export const REPORT_FORMATS = {
  CSV: 'csv',
  EXCEL: 'excel',
};

export const SELECTION_MODES = {
  ALL: 'all',
  CUSTOM: 'custom',
  CURRENT: 'current',
};

export const EXPORT_DIALOG_MODAL_NAME = 'export-dialog';

export const POV_EXPORT_FEATURE = 'rollout.payments.pov_export_dialog';
export const ASYNC_EXPORTS_FEATURE = 'async_exports';
export const TAXES_EXPORT_FEATURE = 'taxes_export';

export const ASYNC_POLL_INTERVAL_MS = 1000;
export const ASYNC_POLL_MAX_RETRIES = 100;

export const DEFAULT_RANGE_MONTHS = 1;

export const REPORT_STATUSES = {
  SUCCESS: 'success',
  PENDING: 'pending',
};
